import { Injectable } from '@angular/core';
import {
  ICommunication,
  ICommunicationStats,
  IWhatsAppCommunicationResult,
  ISendCommunicationRequest,
} from '../models/communication.model';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class CommunicationsService {
  private readonly basePath = '/communications';

  constructor(private apiService: ApiService) {}

  getList(): Promise<ICommunication[]> {
    return this.apiService.request<ICommunication[]>(this.basePath, 'GET');
  }

  getById(id: string): Promise<ICommunication> {
    return this.apiService.request<ICommunication>(
      `${this.basePath}/${id}`,
      'GET',
    );
  }

  getStats(id: string): Promise<ICommunicationStats> {
    return this.apiService.request<ICommunicationStats>(
      `${this.basePath}/${id}/stats`,
      'GET',
    );
  }

  create(data: ISendCommunicationRequest): Promise<ICommunication> {
    return this.apiService.request<ICommunication>(
      `${this.basePath}/create`,
      'POST',
      data,
    );
  }

  update(
    id: string,
    data: Partial<ISendCommunicationRequest>,
  ): Promise<ICommunication> {
    return this.apiService.request<ICommunication>(
      `${this.basePath}/${id}`,
      'POST',
      data,
    );
  }

  send(id: string): Promise<ICommunication> {
    return this.apiService.request<ICommunication>(
      `${this.basePath}/send`,
      'POST',
      { id },
    );
  }

  sendWhatsApp(id: string): Promise<IWhatsAppCommunicationResult> {
    return this.apiService.request<IWhatsAppCommunicationResult>(
      `${this.basePath}/send-whatsapp`,
      'POST',
      { id },
    );
  }

  delete(id: string): Promise<{ success: boolean }> {
    return this.apiService.request<{ success: boolean }>(
      `${this.basePath}/${id}`,
      'DELETE',
    );
  }
}
